import { useTranslation } from 'react-i18next'

import { useScreen } from '../../../../../hooks'
import { FormikField } from '../../../../Formik'
import { InputField } from '../../../../Input'
import {
  BUILDING_FORM_BIC_FIELD_MAX_LENGTH,
  BUILDING_FORM_FIELD_NAME_BIC,
} from '../../BuildingForm.constants'

import { getNextValue } from './BICField.utils'

function BICField() {
  const { t } = useTranslation()

  const { isMobileScreenSize } = useScreen() // TODO make same by css media instead of useScreen

  return (
    <FormikField
      hasCounter
      Component={InputField}
      borderless={!isMobileScreenSize}
      fieldComponentProps={{
        label: `${t('Building.BicLabelKey')}:`,
        shouldAdaptToMobileScreen: true,
      }}
      getNextValue={getNextValue}
      inline={isMobileScreenSize}
      maxLength={BUILDING_FORM_BIC_FIELD_MAX_LENGTH}
      name={BUILDING_FORM_FIELD_NAME_BIC}
      placeholder={t('Building.BicPlaceholderKey')}
    />
  )
}

export default BICField
